export default {
    storeData: async function(data, server, token) {
        const res = await fetch(server + '/storeData', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            },
            body: JSON.stringify(data)
        });
        if(res.ok) {
            console.log('Sync to server successful');
            return await res.json();
        } else {
            console.log(`Error synchronizing: ${res.status} - ${res.statusText}`);
            return null;
        }
    },
    archiveGame: async function(data, server, token) {
        const res = await fetch(server + '/archiveData', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            },
            body: JSON.stringify(data)
        });
        if(res.ok) {
            console.log('Archive game to server successful');
            return await res.json();
        } else {
            console.log(`Error archiving game: ${res.status} - ${res.statusText}`);
            return null;
        }
    },
    getData: async function(server, token) {
        const res = await fetch(server + '/getData', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        });
        if(res.ok) {
            console.log('Retrieve from server successful');
            return await res.json();
        } else {
            console.log(`Error retrieving: ${res.status} - ${res.statusText}`);
            return null;
        }
    },
    getLastSyncDate: async function(server, token) {
        const res = await fetch(server + '/getLastSyncDate', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        });
        if(res.ok) {
            console.log('Retrieved last sync date');
            return await res.json();
        } else {
            console.log(`Error retrieving: ${res.status} - ${res.statusText}`);
            return null;
        }
    }
}